const playbackModes = [
  { value: 'normal', label: 'Normal' },
  { value: 'stop', label: 'Stop' },
  { value: 'holdLastFrame', label: 'Hold' },
  { value: 'loop', label: 'Loop' }
]

const getPlaybackModeLabel = (value) => {
  const mode = playbackModes.find((mode) => mode.value === value)
  return mode?.label
}

export const constants = {
  playbackModes,
  getPlaybackModeLabel
}
